// extracted by mini-css-extract-plugin
export var black = "_48-6";
export var brand = "_48-1";
export var ddefault = "_48-0";
export var error = "_48-3";
export var gray = "_48-2";
export var highContrast = "_48-8";
export var outline = "_48-7";
export var success = "_48-5";
export var warning = "_48-4";